<template>
    <div class="repeater-container">
        <div class="row">
            <div class="col-12">
                <table class="table table-middle table-minimal">
                    <thead>
                        <th scope="col">CSV Label</th>
                        <th scope="col">Map to</th>
                        <th scope="col"></th>
                    </thead>
                    <tbody>
                        <field-row v-for="(_, index) in fields"
                                   :key="index"
                                   :options="options"
                                   v-model="fields[index]"
                                   @delete="$delete(fields, index)"
                        ></field-row>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-right">
                <div class="btn-container">
                    <button class="btn btn-primary" @click.prevent="addField"><i class="fa fa-plus" aria-hidden="true"></i> Add Field</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .repeater-container{
        padding: 0px 0px 15px 0px;
        border-radius: 3px;
        border: 1px solid #dedede;
    }
    .table td, .table th, .table-minimal tr td{
        border-top: 0 !important;
    }
    .btn-container{
        padding: 0px 20px;
    }
</style>

<script>
    import FieldRow from './field-row.vue';
    import axios from 'axios';
    export default {

        name: 'fields-list',

        props: {
            value: {
                type: Array,
                default: [],
            },
            selectedVersion: {
                type: Object|String,
                default: () => ({})
            }
        },

        components: {
            FieldRow
        },

        data: () => ({
            fields: [],
            options: null,
            optionsMaster: null,
            optionsVersion: null,
        }),
        mounted () {
            axios.get('/import-export-profile-fields/')
                .then((response) => {
                    this.optionsMaster = response.data;
                    this.options = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
            axios.get('/import-export-profile-fields-for-versions/')
                .then((response) => {
                    this.optionsVersion = response.data;
                    if (this.selectedVersion.id>0) {
                        this.options = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            this.fields = this.value;
            if (this.fields.length === 0) {
                this.fields.push({});
            }
        },
        methods: {
            addField() {
                this.fields.push({})
            },
            clearFields() {
                this.fields = [{}];
            },
            isLabelDuplicate(rowLabel) {
                const labels = this.fields.map(field => (
                    field.label
                )).filter(label => label === rowLabel);

                return labels.length > 1;
            },
            isMapToDuplicate(f, t) {
                const mapTos = this.fields.filter(field => (field.type === t && field.field === f));

                return mapTos.length > 1;
            },
            optionExists(field, type) {
                if (!this.options) {
                    return null;
                }
                return this.options.filter(option => (option.value.field === field && option.value.type === type)).length > 0;
            },
            changeOptions(version) {
                if (version === 0) {
                    this.options = this.optionsMaster;
                } else {
                    this.options = this.optionsVersion;
                }
            },
        },
        computed: {
            rowsHaveError: function () {
                const errors = this.fields.map(field => (
                    field.errors
                )).filter(errors => {
                    return Object.keys(errors).length !== 0;
                });

                return errors.length > 0;
            },
        },
        watch: {
            fields() {
                this.fields.forEach(field => {
                    field.errors = {};

                    if (this.isLabelDuplicate(field.label)) {
                        field.errors.label = "This label is already used";
                    }

                    if (this.isMapToDuplicate(field.field, field.type)) {
                        field.errors.name = "This mapping is already used";
                    }

                    if (!field.label) {
                        field.errors.label = "Label is required.";
                    }

                    if (this.options && !this.optionExists(field.field, field.type)) {
                        field.errors.name = "Map To is required.";
                    }
                });
                this.$emit('input', this.fields);
            },
            value() {
                this.fields = this.value;
            }
        },
    }
</script>
